import { action, observable } from 'mobx';
import apiCaller from '../../utils/api-caller';
import { v4 } from 'uuid';

class CmsDailyActStore {
  @observable dailyAct = null;
  @observable bannerImages = [];
  @observable loading = false;

  @action getData() {
    this.loading = true;

    return apiCaller.CmsDailyActs.get().then(resp => {
      if (!resp.isError) {
        if (resp.data) {
          this.dailyAct = resp.data;
          this.bannerImages = [];
          this.dailyAct.logoUrl = this.dailyAct.logoUrl || '';
          this.dailyAct.bannerUrl = this.dailyAct.bannerUrl || '';

          if (this.dailyAct.bannerUrl) {
            try {
              let imagesJson = JSON.parse(this.dailyAct.bannerUrl);
              imagesJson.map(imageJson => {
                return imageJson.isLoading = false;
              });
              this.bannerImages = imagesJson;
            } catch {
              this.bannerImages.push({
                id: v4(),
                url: this.dailyAct.bannerUrl,
                isLoading: false
              });
            }
          }

          this.bannerImages.push({
            id: v4(),
            url: '',
            isLoading: false
          });

          this.loading = false;
        }
      }
    })
  }

  @action getDataByLanguageCode() {
    this.loading = true;

    const languageCode = window.localStorage.getItem('lang') || 'en';
    return apiCaller.CmsDailyActs.getByLanguageCode(languageCode).then(resp => {
      if (resp) {
        this.dailyAct = resp;
        this.bannerImages = [];
        this.dailyAct.logoUrl = this.dailyAct.logoUrl || '';
        this.dailyAct.bannerUrl = this.dailyAct.bannerUrl || '';

        if (this.dailyAct.bannerUrl) {
          try {
            let imagesJson = JSON.parse(this.dailyAct.bannerUrl);
            imagesJson.map(imageJson => {
              return imageJson.isLoading = false;
            });
            this.bannerImages = imagesJson;
          } catch {
            this.bannerImages.push({
              id: v4(),
              url: this.dailyAct.bannerUrl,
              isLoading: false
            });
          }
        }

        this.loading = false;
      }
    })
  }

  @action update() {
    this.loading = true;
    this.dailyAct.bannerUrl = JSON.stringify(this.bannerImages.filter(fi => fi.url !== ''));
    return apiCaller.CmsDailyActs.update(this.dailyAct.id, this.dailyAct);
  }

  @action setdescription(langId, value) {
    let lang = this.dailyAct.dailyActLanguages.find(fi => fi.languageId === langId);
    if (lang) {
      lang.description = value;
    }
  }

  @action setloading(value) {
    this.loading = value;
  }

  @action setbannerUrlById(id, value) {
    let image = this.bannerImages.find(fi => fi.id === id);
    if (image) {
      image.url = value;
    }

    let blankImage = this.bannerImages.find(fi => fi.url === '');
    if (!blankImage) {
      this.bannerImages.push({
        id: v4(),
        url: '',
        isLoading: false
      });
    }
  }

  @action setbannerUrlIsLoading(id, isLoading) {
    let image = this.bannerImages.find(fi => fi.id === id);
    if (image) {
      image.isLoading = isLoading;
    }
  }

  @action removeBannerImageById(id) {
    this.bannerImages = this.bannerImages.filter(fi => fi.id !== id);
  }

  @action setlogoUrl(value) {
    this.dailyAct.logoUrl = value;
  }

  @action resetData() {
    this.dailyAct = null;
  }
}

export default new CmsDailyActStore();